import type { MldDealDates, MldLastPayment } from './types';

/**
 * Readers for the `abo/mld` fields added after the first release of the
 * contract. A DS deploy older than these fields omits them, so the payload
 * carries `undefined` where the type says `string | null`: every screen reads
 * them through these helpers, which turn a missing value into `null`.
 */

/** An open paid trial's conversion date, or `null` (also when missing). */
export const mldConvertsOn = (
  dates: Partial<Pick<MldDealDates, 'convertsOn'>> | null | undefined,
): string | null => dates?.convertsOn ?? null;

/** The last paid invoice's item, or `null` (also when missing). */
export const mldLastPaymentItemDescription = (
  payment: Partial<Pick<MldLastPayment, 'itemDescription'>> | null | undefined,
): string | null => payment?.itemDescription ?? null;
